import { Routes, Route } from 'react-router-dom';
import { ContactSessionProvider } from './ContactSessionProvider';
import { PortalLogin } from './PortalLogin';
import { PortalVerify } from './PortalVerify';
import { PortalLayout } from './PortalLayout';
import { PortalHome } from './PortalHome';
import { NutritionView } from './NutritionView';
import { WorkoutView } from './WorkoutView';
import { SessionsView } from './SessionsView';
import { ProfileView } from './ProfileView';

function PortalRoutes() {
  return (
    <Routes>
      <Route path=":workspaceId">
        <Route index element={<PortalLogin />} />
        <Route path="verify" element={<PortalVerify />} />
        <Route element={<PortalLayout />}>
          <Route path="home" element={<PortalHome />} />
          <Route path="nutrition" element={<NutritionView />} />
          <Route path="workout" element={<WorkoutView />} />
          <Route path="sessions" element={<SessionsView />} />
          <Route path="profile" element={<ProfileView />} />
        </Route>
      </Route>
    </Routes>
  );
}

export function PortalApp() {
  return (
    <ContactSessionProvider>
      <PortalRoutes />
    </ContactSessionProvider>
  );
}
